import { PaymentInputOption, QuoteModality } from 'src/utils/constants/quotes';
import { GracePeriodValues, msiTermList } from 'src/utils/constants/distributors';
import { setInitialPayment } from 'src/utils/contracts';

const setGracePeriod = (values, parameter) => {
  if (values.modality === QuoteModality.FIRST_UPFRONT_RENT) {
    return GracePeriodValues.THIRTY;
  }
  if (values.modality === QuoteModality.MSI && values.initialPayment > 0) {
    return GracePeriodValues.ZERO;
  }

  if (values && values.initialPayment === 0) {
    return GracePeriodValues.SAME_DAY_AS_CONTRACT_STARTS;
  }

  return values.gracePeriod ?? parameter.defaultGracePeriod;
};

const makeInitialState = (values, parameter) => {
  return {
    ...values,
    distributorEquipments: values.distributorEquipments,
    totalPriceWithIva: values ? values.totalPriceWithIva : '',
    residualPayment:
      Number(parameter.maxResidualValue) === 0
        ? 1
        : values.residualPayment ?? 1,
    equipmentInsuranceIncluded: values
      ? values.equipmentInsuranceIncluded
      : false,

    initialPayment: setInitialPayment(values),
    gracePeriod: setGracePeriod(values, parameter),
    paymentInputOption: values
      ? values.paymentInputOption
      : PaymentInputOption.PERCENTAGE,
    maxResidualValue: parameter.maxResidualValue ?? null,
    enableResidualValue: parameter.enableResidualValue ?? false,
    selectedTerms:
      values.selectedTerms ??
      msiTermList
        .filter(el => {
          if (!parameter.minMsiTerm || !parameter.maxMsiTerm) return true;
          return (
            Number(el.key) >= Number(parameter.minMsiTerm) &&
            Number(el.key) <= Number(parameter.maxMsiTerm)
          );
        })
        .map(el => Number(el.key))
  };
};

export default makeInitialState;
